/* eslint-disable react-hooks/exhaustive-deps */
// src/pages/UsuarioBucketPage.js
import { useEffect, useState, useContext } from "react";
import { useSearchParams, Link } from "react-router-dom";
import styled from "styled-components";
import { Sidebar } from "../components/Sidebar";
import { AuthContext } from "../context/AuthContext";
import { API_BASE_URL } from "../config";

export const UsuarioBucketPage = () => {
  const { token } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user_id");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [files, setFiles] = useState([]);
  const [usage, setUsage] = useState(null);
  const [filter, setFilter] = useState("");
  const [currentPrefix, setCurrentPrefix] = useState("");
  const [totalFiles, setTotalFiles] = useState(null);

  useEffect(() => {
    document.title = "Arquivos do Bucket";
  }, []);

  useEffect(() => {
    if (!userId) {
      setError("Parâmetro user_id ausente");
      setLoading(false);
      return;
    }

    fetchFiles("");
  }, [userId, token]);

  const fetchFiles = async (prefix = "") => {
    try {
      setLoading(true);

      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_bucket_files.php?user_id=${encodeURIComponent(
          userId,
        )}&prefix=${encodeURIComponent(prefix)}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (!res.ok) {
        setFiles([]);
        setError("");
        setUsage(null);
        setTotalFiles(null);
        return;
      }

      const data = await res.json();
      if (Array.isArray(data?.files)) {
        setFiles(data.files);
        setCurrentPrefix(prefix);
        setError("");
      } else {
        setFiles([]);
        setError(data?.erro || "Não foi possível carregar os arquivos.");
      }

      if (String(prefix || "").startsWith("bcir_backups")) {
        try {
          const resUsage = await fetch(
            `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_bucket_usage_v2.php?user_id=${encodeURIComponent(
              userId,
            )}&prefix=${encodeURIComponent(prefix)}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );

          if (!resUsage.ok) {
            setUsage(null);
          } else {
            const u = await resUsage.json();
            setUsage(u || null);
          }
        } catch {
          setUsage(null);
        }
      } else {
        setUsage(null);
      }

      try {
        const resCount = await fetch(
          `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/count_bucket_files.php?user_id=${encodeURIComponent(
            userId,
          )}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (!resCount.ok) {
          setTotalFiles(null);
        } else {
          const c = await resCount.json();
          setTotalFiles(
            typeof c.total_files === "number" ? c.total_files : null,
          );
        }
      } catch {
        setTotalFiles(null);
      }
    } catch (e) {
      setFiles([]);
      setError("");
      setUsage(null);
      setTotalFiles(null);
    } finally {
      setLoading(false);
    }
  };

  const filtered = files.filter((f) =>
    !filter
      ? true
      : String(f.name || "")
          .toLowerCase()
          .includes(filter.toLowerCase()),
  );

  const handleDownload = async (downloadKey) => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/download_bucket_file.php?user_id=${encodeURIComponent(
          userId,
        )}&key=${encodeURIComponent(downloadKey)}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = await res.json();

      if (data?.download_url) {
        window.open(data.download_url, "_blank");
      } else {
        alert("Link de download indisponível.");
      }
    } catch {
      alert("Erro ao gerar link de download.");
    }
  };

  return (
    <Wrapper>
      <Sidebar />
      <Main>
        <Content>
          <HeaderRow>
            <Title>Arquivos do Bucket</Title>
            <Link
              to="/usuarios"
              style={{
                background: "#2a2a2a",
                color: "#fff",
                borderRadius: 8,
                padding: "0.5rem 0.9rem",
                textDecoration: "none",
              }}
            >
              ⬅ Voltar para Usuários
            </Link>
          </HeaderRow>

          <Section>
            <div
              style={{
                marginBottom: 12,
                display: "flex",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <Badge>ID do usuário: {userId || "-"}</Badge>

              {/* NOVO: Plano + uso, se aplicável (BACKUP_TYPE 1 ou 2) */}
              {usage && usage.show_usage !== false && (
                <Badge>
                  Plano: {usage.storage_plan || "-"}
                  {typeof totalFiles === "number" && (
                    <>
                      {" "}
                      {" | Arquivos: "}
                      {totalFiles}
                    </>
                  )}
                  {typeof usage.used_bytes === "number" && (
                    <>
                      {" | Usado: "}
                      {formatSize(usage.used_bytes)}
                      {typeof usage.storage_plan_bytes === "number" &&
                        usage.storage_plan_bytes > 0 && (
                          <> / {formatSize(usage.storage_plan_bytes)}</>
                        )}
                    </>
                  )}
                </Badge>
              )}

              <input
                type="text"
                placeholder="Filtrar por nome do arquivo"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                style={{
                  background: "#2a2a2a",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "0.6rem 0.8rem",
                  minWidth: 260,
                }}
              />

              {currentPrefix && (
                <button
                  onClick={() =>
                    fetchFiles(currentPrefix.replace(/[^/]+\/$/, ""))
                  }
                  style={{
                    background: "#0084c2",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "0.6rem 1rem",
                    cursor: "pointer",
                    marginBottom: 12,
                  }}
                >
                  ⬅ Voltar uma pasta
                </button>
              )}
            </div>

            {loading ? (
              <p>Carregando...</p>
            ) : error ? (
              <ErrorText>{error}</ErrorText>
            ) : filtered.length === 0 ? (
              <EmptyState>
                <p>Nenhum arquivo encontrado para este usuário.</p>
              </EmptyState>
            ) : (
              <TableViewport>
                <Table>
                  <thead>
                    <tr>
                      <th>Arquivo</th>
                      <th>Tamanho</th>
                      <th>Última modificação</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((f, idx) => (
                      <tr key={idx}>
                        <td style={{ maxWidth: 520, wordBreak: "break-all" }}>
                          {String(f.name || "").endsWith("/") ? (
                            <span
                              style={{ cursor: "pointer", color: "#4f46e5" }}
                              onClick={() => fetchFiles(f.name)}
                            >
                              📁{" "}
                              {String(f.name)
                                .replace(currentPrefix, "")
                                .replace(/\/$/, "")}
                            </span>
                          ) : (
                            <>
                              📄{" "}
                              {String(f.name || "-").replace(currentPrefix, "")}
                            </>
                          )}
                        </td>
                        <td>{formatSize(f.size_bytes)}</td>
                        <td>{formatDate(f.last_modified)}</td>
                        <td>
                          {/* ÚNICA ação permitida: Download */}
                          {String(f.name || "").endsWith("/") ? (
                            <button
                              disabled
                              style={{ ...downloadBtnStyle, opacity: 0.5 }}
                              title="Pastas não podem ser baixadas diretamente"
                            >
                              Baixar
                            </button>
                          ) : f.download_key ? (
                            <a
                              href={f.download_url}
                              target="_blank"
                              rel="noreferrer"
                              style={downloadBtnStyle}
                            >
                              Baixar
                            </a>
                          ) : (
                            <button
                              disabled
                              style={{ ...downloadBtnStyle, opacity: 0.5 }}
                              title="Link de download indisponível"
                            >
                              Baixar
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableViewport>
            )}
          </Section>
        </Content>
      </Main>
    </Wrapper>
  );
};

function formatSize(bytes) {
  if (!Number.isFinite(bytes)) return "-";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = Math.max(bytes, 0);
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 && i > 0 ? 2 : 0)} ${units[i]}`;
}

function formatDate(ts) {
  if (!ts) return "-";
  try {
    const d = new Date(ts);
    if (isNaN(d.getTime())) return String(ts);
    return d.toLocaleString("pt-BR");
  } catch {
    return String(ts);
  }
}

const downloadBtnStyle = {
  background: "#4f46e5",
  color: "#fff",
  padding: "0.35rem 0.75rem",
  borderRadius: 6,
  textDecoration: "none",
  border: "none",
  cursor: "pointer",
};

const Wrapper = styled.div`
  min-height: 100dvh;
  background: #0f0f0f;
  color: #fff;
  padding-top: 60px;
  padding-left: 240px;

  @media (max-width: 760px) {
    padding-left: 0;
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Content = styled.div`
  padding: 2rem;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h3`
  margin-bottom: 1.5rem;
`;

const Section = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  padding: 1.5rem;
`;

const TableViewport = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  margin-top: 0.75rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #333;
    text-align: left;
    white-space: nowrap;
  }
  th {
    color: #ccc;
  }
  td {
    color: #eee;
  }
`;

const Badge = styled.span`
  background: #2a2a2a;
  display: inline-block;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  font-size: 0.9rem;
`;

const ErrorText = styled.div`
  color: #ff6b6b;
  background: #2a1212;
  padding: 0.8rem 1rem;
  border-radius: 8px;
`;

const EmptyState = styled.div`
  background: #121212;
  border: 1px dashed #2a2a2a;
  border-radius: 8px;
  padding: 1.2rem;
  color: #bbb;
  text-align: center;
`;
